import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import ClearableInput, {
  SettingsField,
} from '../../../components/Settings/ClearableInput'
import SettingsCard from '../../../components/Settings/SettingsCard'
import { socialUrlStatus } from '../../../lib/socialLinks'

export default function CharityAboutCard({
  charity,
  onFieldChange,
  onSave,
  hasChanged,
  isSaving,
}) {
  const { t } = useTranslation()
  const websiteStatus = socialUrlStatus(charity?.website_url)

  return (
    <SettingsCard
      icon="edit"
      title={t('charities.settings.about_title')}
      description={t('charities.settings.about_note')}
      actions={
        <>
          <button
            className="btn btn-primary"
            type="button"
            onClick={onSave}
            disabled={!hasChanged || isSaving || websiteStatus === 'invalid'}
          >
            {isSaving ? t('users.edit.saving') : t('charities.settings.save')}
          </button>
          {websiteStatus === 'invalid' && (
            <span className="text-danger small">
              {t(
                'users.edit.socials_invalid',
                'Fix the highlighted links before saving.',
              )}
            </span>
          )}
        </>
      }
    >
      <div className="row g-3">
        <div className="col-md-6">
          <SettingsField
            label={t('charities.settings.website')}
            htmlFor="website_url"
            status={websiteStatus}
            help={
              websiteStatus === 'invalid'
                ? t(
                    'users.edit.social_invalid_url',
                    'Enter a full URL, e.g. https://example.com/you',
                  )
                : null
            }
            helpVariant={websiteStatus === 'invalid' ? 'error' : undefined}
          >
            <ClearableInput
              id="website_url"
              name="website_url"
              type="url"
              placeholder={t('charities.settings.website_placeholder')}
              value={charity?.website_url || ''}
              onChange={value => onFieldChange('website_url', value)}
              onClear={() => onFieldChange('website_url', '')}
              clearLabel={t('settings.field.clear', 'Clear')}
            />
          </SettingsField>
        </div>
        <div className="col-12">
          <SettingsField
            label={t('charities.settings.mission')}
            htmlFor="mission"
          >
            <textarea
              id="mission"
              name="mission"
              className="form-control"
              rows={4}
              value={charity?.mission || ''}
              placeholder={t('charities.settings.mission_placeholder')}
              onChange={event => onFieldChange('mission', event.target.value)}
            />
          </SettingsField>
        </div>
      </div>
    </SettingsCard>
  )
}

CharityAboutCard.propTypes = {
  charity: PropTypes.object,
  onFieldChange: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  hasChanged: PropTypes.bool,
  isSaving: PropTypes.bool,
}
